<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>视光配镜</el-breadcrumb-item>
      <el-breadcrumb-item>出货</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.orderid" @keyup.enter.native="clicksearch" placeholder="请输入订单号" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.orderstatus" placeholder="请选择" class="select"  style="width: 200px;">
              <el-option label="请选择订单状态" value="-1"></el-option>
              <el-option label="待支付" value="0"></el-option>
              <el-option label="待发货" value="1"></el-option>
              <el-option label="待收货" value="2"></el-option>
              <el-option label="已完成" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.shipmenttime" @keyup.enter.native="clicksearch" placeholder="请输入出货时间" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <!-- 数据列表 start -->
        <el-table :data="dataList" border stripe>
          <el-table-column type="expand" min-width="1%">
            <template slot-scope="props">
              <el-table :data="props.row.ListSub" height="200" class="tableInner" :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center' }">
                <el-table-column prop="Producttype" label="产品类型"></el-table-column>
                <el-table-column prop="Brand" label="品牌"></el-table-column>
                <el-table-column prop="Productname" label="商品名称"></el-table-column>
                <el-table-column prop="Specifications" label="规格型号"></el-table-column>
                <el-table-column prop="Units" label="计量单位"></el-table-column>
                <el-table-column prop="Shipmentnum" label="出货数量"></el-table-column>
                <el-table-column prop="Salesamount" label="销售金额"></el-table-column>
                <el-table-column prop="Note" label="备注"></el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column prop="Orderid" label="订单号" min-width="6%"></el-table-column>
          <el-table-column prop="Shipmenttime" label="出货时间" min-width="6%"></el-table-column>
          <el-table-column prop="Customername" label="收货人" min-width="6%"></el-table-column>
          <el-table-column prop="Phone" label="手机号码" min-width="6%"></el-table-column>
          <el-table-column prop="Consigneeaddress" label="收件地址" min-width="6%"></el-table-column>
          <el-table-column prop="Ordertime" label="下单时间" min-width="6%"></el-table-column>
          <el-table-column prop="Reduceamount" label="已优惠金额" min-width="6%"></el-table-column>
          <el-table-column prop="Endamount" label="最终金额" min-width="6%"></el-table-column>
          <el-table-column prop="Deliverytype" label="发货形式" min-width="6%"></el-table-column>
          <el-table-column prop="Trackingnumber" label="物流单号" min-width="6%"></el-table-column>
          <el-table-column prop="OrderstatusName" label="订单状态" min-width="6%"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" min-width="8%"></el-table-column>
          <el-table-column prop="operation" label="操作" min-width="8%">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickdel(scope.row)">删除</el-button>
              <el-button v-if="scope.row.Orderstatus == 1 || scope.row.Orderstatus == 2" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickmodify(scope.row)">填写发货信息</el-button>
              <el-button v-if="scope.row.Orderstatus == 2" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickConfirmGoods(scope.row)">确认收货</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 数据列表 end -->

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
            :current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

    <!-- 添加 start -->
    <el-tab-pane label="添加出货" name="second">
      <el-form :model="addForm" ref="addFormRef" label-width="170px">
        <el-form-item label="出货时间" class="addAdminForm">
          <el-date-picker v-model="addForm.shipmenttime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="产品类型" class="addAdminForm">
          <el-select v-model="addForm.producttype" placeholder="请选择产品类型" @change="selectchange(1)">
            <el-option
              v-for="item in ProducttypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="品牌" class="addAdminForm">
          <el-select v-model="addForm.brand" placeholder="请选择品牌" @change="selectchange(2)">
            <el-option
              v-for="item in BrandOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品名称" class="addAdminForm">
          <el-select v-model="addForm.productname" placeholder="请选择商品名称" @change="selectchange(3)">
            <el-option
              v-for="item in ProductNameOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="规格型号" >
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
          <div style="margin: 15px 0;"></div>
          <el-checkbox-group v-model="checkedSpecificationsOptions" @change="handleCheckedCitiesChange">
            <el-checkbox v-for="option in allSpecificationsOptions" :label="option" :key="option">{{option}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="计量单位" class="addAdminForm">
          <el-input v-model="addForm.units"></el-input>
        </el-form-item>
        <el-form-item label="收货人" class="addAdminForm">
          <el-input v-model="addForm.customername"></el-input>
        </el-form-item>
        <el-form-item label="手机号码" class="addAdminForm">
          <el-input v-model="addForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="收件地址" class="addAdminForm">
          <el-input v-model="addForm.consigneeaddress"></el-input>
        </el-form-item>
        <el-form-item label="下单时间" class="addAdminForm">
          <el-date-picker v-model="addForm.ordertime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="出货数量" class="addAdminForm">
          <el-input v-model="addForm.shipmentnum"></el-input>
        </el-form-item>
        <el-form-item label="总销售金额" class="addAdminForm">
          <el-input v-model="addForm.salesamount"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickadd">添加</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- 添加 end -->

    <!-- 发货 start -->
    <el-tab-pane label="发货" name="three" disabled="disabled">
      <el-form :model="editForm" ref="editFormRef" label-width="170px">
        <el-form-item label="发货形式" class="addAdminForm">
          <el-input v-model="editForm.deliverytype"></el-input>
        </el-form-item>
        <el-form-item label="物流单号" class="addAdminForm">
          <el-input v-model="editForm.trackingnumber"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clicksave">保存</el-button>
          <el-button type="info" @click="clickreturn">返回</el-button>
        </el-form-item>
      </el-form>
    </el-tab-pane>
    <!-- 发货 end -->

  </el-tabs>
  </div>
</template>

<script>
import TencentyunCosUploadExcel from '@/components/TencentyunCosUploadExcel.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    TencentyunCosUploadExcel
  },
  name: 'MyOptometristProductout',
  data () {
    return {
      activeName: 'first',
      ProducttypeOptions: [],
      BrandOptions: [],
      ProductNameOptions: [],
      addForm: {
        shipmenttime: '',
        producttype: '',
        brand: '',
        productname: '',
        units: '',
        customername: '',
        phone: '',
        consigneeaddress: '',
        ordertime: '',
        shipmentnum: '0',
        salesamount: '0'
      },
      addFormBack:[],
      editForm: {
        orderid: '',
        deliverytype: '',
        trackingnumber: ''
      },
      // 查询
      keywords: {
        orderid: '',
        orderstatus: '-1',
        shipmenttime: '',
        suppliers: '',
        productname: '',
        specifications: ''
      },
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1,
      checkAll: false,
      checkedSpecificationsOptions: [],
      allSpecificationsOptions: [],
      isIndeterminate: false
    }
  },
  mounted () {
    this.addFormBack = Vue.prototype.CloneObj(this.addForm)

    this.apiGetOptometristOrderNum()
    this.apiGetOptometristOrderList()

    this.apiGetOptometristSuppliersClassification(0,"","","")
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
    },
    selectchange(ptype){
      // 选择了产品类型
      if(ptype == 1 || ptype == 11){
        this.BrandOptions = []
        this.ProductNameOptions = []
        this.checkedSpecificationsOptions = []
        this.allSpecificationsOptions = []
        this.checkAll = false
        this.isIndeterminate = false
        if(ptype == 1){
          //新增
          this.addForm.brand = ''
          this.addForm.productname = ''
          this.apiGetOptometristSuppliersClassification(1,this.addForm.producttype,"","")
        }
      }
      // 选择了供应商
      if(ptype == 2 || ptype == 22){
        this.ProductNameOptions = []
        this.checkedSpecificationsOptions = []
        this.allSpecificationsOptions = []
        this.checkAll = false
        this.isIndeterminate = false
        if(ptype == 2){
          //新增
          this.addForm.productname = ''
          this.apiGetOptometristSuppliersClassification(2,this.addForm.producttype,this.addForm.brand,"")
        }
      }
      // 选择了商品名称
      if(ptype == 3 || ptype == 33){
        this.checkedSpecificationsOptions = []
        this.allSpecificationsOptions = []
        this.checkAll = false
        this.isIndeterminate = false
        if(ptype == 3){
          //新增
          this.apiGetOptometristSuppliersClassification(3,this.addForm.producttype,this.addForm.brand,this.addForm.productname)
        }
      }
    },
    handleCheckAllChange(val) {
      this.checkedSpecificationsOptions = val ? this.allSpecificationsOptions : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.allSpecificationsOptions.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.allSpecificationsOptions.length;
    },
    clickadd () {
      this.apiAddOptometristProductout()
    },
    clickmuban () {
      window.open('https://erp-1256233047.cos.ap-shanghai.myqcloud.com/muban/%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF%E9%85%8D%E9%95%9C%E5%87%BA%E8%B4%A7.xlsx')
    },
    changeTencentyunCosUploadExcel (url) {
      this.apiExcelImport('22102502',url)
    },
    clicksave () {
      this.apiEditOptometristOrder()
    },
    clickreturn () {
      this.activeName = 'first'
    },
    clickdel (row) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDelOptometristProductout(row.Orderid)
      })
    },
    clickmodify (row) {
       this.activeName = 'three'

       this.editForm.orderid = row.Orderid
       this.editForm.deliverytype = row.Deliverytype
       this.editForm.trackingnumber = row.Trackingnumber
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetOptometristOrderNum()
      this.apiGetOptometristOrderList()
    },
    delaysearch () {
      var that = this
      setTimeout(function () {
        that.clicksearch()
      }, 2000)
    },
    clickConfirmGoods(row){
      this.$confirm('是否确认收货?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiConfirmGoodsOptometristProductout(row.Orderid)
      })
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetOptometristOrderList()
    },
    apiGetOptometristSuppliersClassification: function (ptype, producttype, brand, productname) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        ptype: ptype,
        producttype: producttype,
        brand: brand,
        productname: productname
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetOptometristSuppliersClassification, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code == 200) {
            if(ptype == 0) {
              that.ProducttypeOptions = []
              response.data.List.filter((item, i) => {
                that.ProducttypeOptions.push({ value: item.Name, label: item.Name })
              })
            }
            if(ptype == 1) {
              that.BrandOptions = []
              response.data.List.filter((item, i) => {
                that.BrandOptions.push({ value: item.Name, label: item.Name })
              })
            }
            if(ptype == 2) {
              that.ProductNameOptions = []
              response.data.List.filter((item, i) => {
                that.ProductNameOptions.push({ value: item.Name, label: item.Name })
              })
            }
            if(ptype == 3) {
              that.checkedSpecificationsOptions = []
              that.allSpecificationsOptions = []
              that.checkAll = false
              that.isIndeterminate = false
              response.data.List.filter((item, i) => {
                that.allSpecificationsOptions.push(item.Name)
              })
            }
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetOptometristProductoutNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        shipmenttime: that.keywords.shipmenttime,
        producttype: that.keywords.producttype,
        brand: that.keywords.brand,
        productname: that.keywords.productname,
        specifications: that.keywords.specifications
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetOptometristProductoutNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetOptometristProductoutList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        shipmenttime: that.keywords.shipmenttime,
        producttype: that.keywords.producttype,
        brand: that.keywords.brand,
        productname: that.keywords.productname,
        specifications: that.keywords.specifications
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetOptometristProductoutList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddOptometristProductout: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        specifications: that.checkedSpecificationsOptions.toString()
      }
      data = { ...data, ...that.addForm }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddOptometristProductout, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetOptometristOrderNum()
            that.apiGetOptometristOrderList()

            // 清空
            that.addForm = Vue.prototype.CloneObj(that.addFormBack)
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiDelOptometristProductout: function (orderid) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: orderid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DelOptometristProductout, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetOptometristOrderNum()
            that.apiGetOptometristOrderList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    // apiEditOptometristProductout: function () {
    //   var that = this
    //   var useriderp = localStorage.getItem('Useriderp')
    //   var timestamp = Date.parse(new Date()) / 1000
    //   var data = {
    //     os: 'erp',
    //     useriderp: useriderp,
    //     timestamp: timestamp,
    //     localfingerprint: Vue.prototype.FunGetLocalFingerprint()
    //   }
    //   data = { ...data, ...that.editForm }
    //   // 加上签名
    //   data.sign = Vue.prototype.FunGetSignErp(data)
    //   axios.post(Vue.prototype.global.Url_EditOptometristProductout, Qs.stringify(data))
    //     .then(function (response) {
    //       Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
    //         that.activeName = 'first'
    //         that.apiGetOptometristOrderNum()
    //         that.apiGetOptometristOrderList()
    //       })
    //     })
    //     .catch(function (error) {
    //       Vue.prototype.FunLogError(error)
    //     })
    // },
    apiExcelImport: function (exceltype,url) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        exceltype: exceltype,
        fileurl: url
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExcelImport, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
          that.delaysearch()
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetOptometristOrderNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        shipmenttime: that.keywords.shipmenttime,
        orderid: that.keywords.orderid,
        orderstatus: that.keywords.orderstatus,
        querytype: 2
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetOptometristOrderNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetOptometristOrderList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        shipmenttime: that.keywords.shipmenttime,
        orderid: that.keywords.orderid,
        orderstatus: that.keywords.orderstatus,
        querytype: 2
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetOptometristOrderList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditOptometristOrder: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      data = { ...data, ...that.editForm }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditOptometristOrder, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetOptometristOrderNum()
            that.apiGetOptometristOrderList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiConfirmGoodsOptometristProductout: function (orderid) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: orderid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ConfirmGoodsOptometristProductout, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.apiGetOptometristOrderNum()
            that.apiGetOptometristOrderList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
</style>
